import label from "@/lang/StaticLabels.js";

let navItems = [
  {
    to: "Dashboard",
    label: label.navbar.Dashboard,
    icon: "mdi-view-dashboard",
    active: false,
    subItems: false,
  },
  {
    to: null,
    label: label.menu.baseInformation,
    icon: "mdi-database",
    active: false,
    subItems: [
      {
        to: "FileManagement",
        label: label.navbar.FileManagement,
        icon: "mdi-subdirectory-arrow-left",
      },
      {
        to: "Categories",
        label: label.navbar.Categories,
        icon: "mdi-subdirectory-arrow-left",
      },
      {
        to: "TicketCategory",
        label: label.navbar.TicketCategory,
        icon: "mdi-subdirectory-arrow-left",
      },
      {
        to: "TheUnit",
        label: label.navbar.TheUnit,
        icon: "mdi-subdirectory-arrow-left",
      },
      {
        to: "Config",
        label: label.navbar.config,
        icon: "mdi-subdirectory-arrow-left",
      },
      {
        to: "OrdersSetting",
        label: "تنظیمات سفارشات",
        icon: "mdi-subdirectory-arrow-left",
      },
      {
        to: "Cars",
        label: "مدیریت خودروها",
        icon: "mdi-subdirectory-arrow-left",
      },
      {
        to: "SaleType",
        label: "مدیریت انواع فروش",
        icon: "mdi-subdirectory-arrow-left",
      },
    ],
  },
  {
    to: null,
    label: "ظاهر و صفحات وبسایت",
    icon: "mdi-animation-outline",
    active: false,
    subItems: [
      {
        to: "BannersAndSliders",
        label: "بنر و اسلایدر",
        icon: "mdi-subdirectory-arrow-left",
      },
      {
        to: "SocialNetworks",
        label: "شبکه های اجتماعی",
        icon: "mdi-subdirectory-arrow-left",
      },
      {
        to: "Menus",
        label: "مدیریت منو ها",
        icon: "mdi-subdirectory-arrow-left",
      },
      {
        to: "ManagePages",
        label: "مدیریت صفحات",
        icon: "mdi-subdirectory-arrow-left",
      },
      {
        to: "Poster",
        label: "پوسترها",
        icon: "mdi-subdirectory-arrow-left",
      },
      {
        to: "Widgets",
        label: "ویجت ها",
        icon: "mdi-subdirectory-arrow-left",
      },
    ],
  },
  {
    to: null,
    label: label.navbar.ServicesAndProducts,
    icon: "mdi-cog-box",
    active: false,
    subItems: [
      {
        to: "AddService",
        label: label.navbar.AddService,
        icon: "mdi-subdirectory-arrow-left",
      },
      {
        to: "ServicesList",
        label: label.navbar.Services,
        icon: "mdi-subdirectory-arrow-left",
      },
      {
        to: "AddProduct",
        label: label.navbar.AddProduct,
        icon: "mdi-subdirectory-arrow-left",
      },
      {
        to: "ProductsList",
        label: label.navbar.ProductsList,
        icon: "mdi-subdirectory-arrow-left",
      },
      {
        to: "Orders",
        label: "سفارشات",
        icon: "mdi-subdirectory-arrow-left",
      },

      {
        to: "ReturnedOrders",
        label: "سفارشات مرجوعی",
        icon: "mdi-subdirectory-arrow-left",
      },
      {
        to: "ProductFeatures",
        label: "ویژگی‌های محصول",
        icon: "mdi-subdirectory-arrow-left",
      },
      {
        to: "Transaction",
        label: "تراکنش ها",
        icon: "mdi-subdirectory-arrow-left",
      },
    ],
  },
  {
    to: null,
    label: label.navbar.Brands,
    icon: "mdi-office-building",
    active: false,
    subItems: [
      {
        to: "AddBrand",
        label: label.navbar.AddBrand,
        icon: "mdi-subdirectory-arrow-left",
      },
      {
        to: "BrandsList",
        label: label.navbar.ManageBrands,
        icon: "mdi-subdirectory-arrow-left",
      },
    ],
  },
  {
    to: null,
    label: label.navbar.Blogs,
    icon: "mdi-post",
    active: false,
    subItems: [
      {
        to: "AddBlog",
        label: label.navbar.AddBlog,
        icon: "mdi-subdirectory-arrow-left",
      },
      {
        to: "TheBlogs",
        label: label.navbar.ManageBlogs,
        icon: "mdi-subdirectory-arrow-left",
      },
    ],
  },
  {
    to: null,
    label: "مخاطبین و بازدیدکنندگان",
    icon: "mdi-account-group-outline",
    active: false,
    subItems: [
      // {
      //   to: "Branches",
      //   label: "درخواست های نمایندگی",
      //   icon: "mdi-subdirectory-arrow-left",
      // },
      {
        to: "NewsLetter",
        label: "خبرنامه",
        icon: "mdi-subdirectory-arrow-left",
      },
      {
        to: "GuestContactMessage",
        label: "مدیریت تماس با ما",
        icon: "mdi-message-text",
      },
    ],
  },
  // {
  //   to: null,
  //   label: label.menu.reports,
  //   icon: "mdi-chart-bar",
  //   active: false,
  //   subItems: [
  //     {
  //       to: "SalesOfficeByCommodity",
  //       label: label.menu.SalesOfficeByCommodity,
  //       icon: "mdi-subdirectory-arrow-left",
  //     },

  //     {
  //       to: "ConsumingMaterial",
  //       label: label.menu.ConsumingMaterial,
  //       icon: "mdi-subdirectory-arrow-left",
  //     },
  //   ],
  // },
  {
    to: null,
    label: "تخفیف و نظرسنجی",
    icon: "mdi-gift",
    active: false,
    subItems: [
      {
        to: "ListFestivals",
        label: label.navbar.ListFestivals,
        icon: "mdi-subdirectory-arrow-left",
      },
      {
        to: "PollsList",
        label: "نظرسنجی",
        icon: "mdi-subdirectory-arrow-left",
      },
    ],
  },
  {
    to: "TicketsList",
    label: label.navbar.Tickets,
    icon: "mdi-ticket",
    active: false,
  },
  {
    to: null,
    label: label.navbar.ManageComments,
    icon: "mdi-comment-text",
    active: false,
    subItems: [
      {
        to: "BlogComments",
        label: label.navbar.BlogComments,
        icon: "mdi-subdirectory-arrow-left",
      },
      {
        to: "ProductComments",
        label: label.navbar.ProductComments,
        icon: "mdi-subdirectory-arrow-left",
      },
    ],
  },

  // {
  //   to: null,
  //   label: label.menu.opertaion,
  //   icon: "mdi-shopping",
  //   active: false,
  //   subItems: [
  //     {
  //       to: "BuyList",
  //       label: label.menu.Buy,
  //       icon: "mdi-subdirectory-arrow-left",
  //     },
  //   ],
  // },
  {
    to: null,
    label: label.menu.peopleManagement,
    icon: "mdi-account-multiple",
    active: false,
    subItems: [
      {
        to: "UsersManagement",
        label: "مدیریت کاربران",
        icon: "mdi-subdirectory-arrow-left",
      },
      {
        to: "CustomersManagement",
        label: "مدیریت مشتریان",
        icon: "mdi-subdirectory-arrow-left",
      },
      {
        to: "Roles",
        label: label.menu.Roles,
        icon: "mdi-subdirectory-arrow-left",
      },
    ],
  },
  
];

export default navItems;
